import { render } from "./final_production.vue?vue&type=template&id=dfee62ba"
import script from "./final_production.vue?vue&type=script&lang=js"
export * from "./final_production.vue?vue&type=script&lang=js"

import "./final_production.vue?vue&type=style&index=0&id=dfee62ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__